import Cookies from "js-cookie";
import React from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import CriticMain from "../Components/CriticMain/CriticMain";
import Feedback from "../Components/Feedback/Feedback";
import ReaderView from "../Components/ReaderView/ReaderView";
import CriticDash from "../Components/CriticDash/CriticDash";
import { getInfo } from "../utils/hooks";

const CriticLayout: React.FC = () => {
    const userInfo = getInfo();

    if (userInfo === null) {
        return <Redirect to="/login" />;
    } else if (Cookies.get("admin")) {
        return <Redirect to="/admin" />;
    } else if (userInfo.intent === "writer") {
        return <Redirect to="/writer" />;
    } else if (userInfo.intent === "producer") {
        return <Redirect to="/producer" />;
    }

    return (
        <Switch>
            <Route path="/critic/read/:id" component={ReaderView} />
            <Route path="/critic/dashboard" component={CriticDash} />
            {/* <Route path="/critic/feedback/:id" component={Feedback} /> */}
            <Route exact path="" component={CriticMain} />
        </Switch>
    );
};

export default CriticLayout;
